export { default as authorAdapter } from './adapter';
export { default as Author } from './Author';
